import styles from "./styles.module.css";
import error404 from "../../assets/img/error-404.svg";
import { Link } from "react-router-dom";

function NotFound() {
  return (
    <section className={styles.notfoundPage}>
      <main>
        <img src={error404} alt="Pagina não encontrada" />{" "}
        <h2>Ops, Pagina não encontrada</h2>
        <hr className={styles.separador} />
        <Link to="/">❮❮ Voltar para a pagina Inicial</Link>
      </main>
    </section>
  );
}
export default NotFound;
